import FormBaseModel from '@cp-models/FormBaseModel'

export default class Address extends FormBaseModel {
    casts()
    {
        return {
            'id': 'number',
            'supplier_id': 'number',
            'street': 'string',
            'number': 'string',
            'district': 'string',
            'city': 'string',
            'state': 'string',
            'zip_code': 'string',
            'country': 'string',
            'complement': 'string',
        }
    }
}
